module.exports = __webpack_public_path__ + "static/img/15.f879ff4f.png";